import React from "react";
import "./App.css";

export default function Footer() {
  return (
    <p className="github-link">
      <a href="https://github.com/caroolcanelas/Weather-app-react">
        Open-source
      </a>
      by Carol Canelas
    </p>
  );
}
